import React, { useRef } from 'react';

import './ExploreSection.css';

const EXPLORE_CARDS = [
  { 
    to: '/pricing-fulfilment-services', 
    label: 'Fulfilment Pricing', 
    desc: 'Transparent rates, no hidden fees.', 
    linkText: 'View pricing',
    iconColor: '#F68C43',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#F68C43" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>,
    img: '/homepageimages/pricing-book.jpg' 
  },
  { 
    to: '/case-studies', 
    label: 'Case Studies', 
    desc: 'Real results from brands we scale in the UK.', 
    linkText: 'Read case studies',
    iconColor: '#1A44E5',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1A44E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline></svg>,
    img: '/homepageimages/case-studies.jpg' 
  },
  { 
    to: '/our-reviews', 
    label: 'Customer Reviews', 
    desc: 'See what our clients say.', 
    linkText: 'Read reviews',
    iconColor: '#F68C43',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#F68C43" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>,
    img: '/homepageimages/reviews.jpg' 
  },
  { 
    to: '/integrations', 
    label: 'eCommerce Integrations', 
    desc: 'Amazon, Shopify, TikTok Shop, eBay & more.', 
    linkText: 'View integrations',
    iconColor: '#1A44E5',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1A44E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>,
    img: '/homepageimages/integrations.jpg' 
  },
  { 
    to: '/fulfillment-blog', 
    label: 'Fulfilment Blog', 
    desc: 'Guides, tips and industry insights.', 
    linkText: 'Read the blog',
    iconColor: '#F68C43',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#F68C43" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>,
    img: '/homepageimages/blog.jpg' 
  },
  { 
    to: '/contact-fulfillment-services', 
    label: 'Get a Free Quote', 
    desc: "Tell us your volumes and we'll get back the same day.", 
    linkText: 'Get a quote',
    iconColor: '#1A44E5',
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1A44E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>,
    img: '/homepageimages/quote.jpg' 
  },
];

const ExploreSection: React.FC = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <section className="explore-section">
      <div className="explore-container">
        
        {/* Left Side Content */}
        <div className="explore-left">
          <div className="explore-eyebrow">
            <span className="explore-dash"></span>
            RESOURCES & INSIGHTS
          </div>
          
          <h2 className="explore-title">
            Explore <br />
            <span className="text-blue">Pick Pack Pro</span>
          </h2>
          
          <p className="explore-desc">
            Everything you need to understand, compare and start your fulfilment journey — all in one place.
          </p>
          
          
          
          
        </div>

        {/* Right Side Carousel */}
        <div className="explore-right" ref={scrollRef}>
          <div className="explore-carousel">
            {EXPLORE_CARDS.map((card, idx) => (
              <a href={card.to} className={`explore-card ${idx === 0 ? 'active' : ''}`} key={idx}>
                <div className="ec-img-wrap">
                  {/* Fallback grey background if image not found */}
                  <div className="ec-img-placeholder" style={{ backgroundImage: `url('${card.img}')` }}></div>
                  <div className="ec-floating-icon" style={{ color: card.iconColor }}>
                    {card.icon}
                  </div>
                </div>
                <div className="ec-content">
                  <h3 className="ec-title">{card.label}</h3>
                  <p className="ec-desc">{card.desc}</p>
                  
                  <div className="ec-link">
                      {card.linkText} 
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                    </div>
                  </div>
                </a>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default ExploreSection;


